import { style } from "@vanilla-extract/css";
import { borderedCell } from "plos/src/styles";
import { vars } from "plos/src/styles/theme.css";

export const transfersTableCell = style({
  padding: vars.space.xs,
  textAlign: "end",
});

export const styledElementInfoButton = style({
  padding: vars.space.none,
});

export const transfersElementCell = style([
  borderedCell,
  {
    padding: 0,
  },
]);
